import { Button } from '@mui/material';
import { DataCellProps } from '../types';
import { FC } from 'react';
import { MemberRoles } from 'TeamModule/constants/member';

export const TeamMemberImpersonateCell: FC<DataCellProps> = ({ onImpersonate, member }) => {
  const { buttonLabel, impersonationDisabled } = member?.is_archived
    ? {
        impersonationDisabled: true,
        buttonLabel: 'Member archived',
      }
    : member?.role_name === MemberRoles.NoAccess
      ? {
          impersonationDisabled: true,
          buttonLabel: 'No access to the Mosaic team',
        }
      : {
          buttonLabel: 'Impersonate',
          impersonationDisabled: false,
        };

  const handleImpersonateClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    event.stopPropagation();
    onImpersonate(event);
  };

  return (
    <Button
      color="primary"
      variant="outlined"
      onClick={impersonationDisabled ? undefined : handleImpersonateClick}
      disabled={impersonationDisabled}
    >
      {buttonLabel}
    </Button>
  );
};
